import {FleetHeatmapGridRequest, HeatmapGrid} from "../../../model/heatmap";
import {otsBaseApi} from "../../ots-api";

const ALL_TAG_TYPES = [] as const;

type TagType = typeof ALL_TAG_TYPES[number];

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: ALL_TAG_TYPES
});

const fleetHeatmapApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFleetHeatmapGrid: builder.query<HeatmapGrid, FleetHeatmapGridRequest>({
      query: (arg) => ({
        url: `/fleet/heatmap/grid`,
        method: "POST",
        body: arg
      }),
    }),
  })
});

export const {
  useGetFleetHeatmapGridQuery,
  useLazyGetFleetHeatmapGridQuery,
} = fleetHeatmapApi;
